"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    show: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    background: _propTypes.default.string,
    zIndex: _propTypes.default.number,
    isAnimationOn: _propTypes.default.bool,
    height: _propTypes.default.string,
    animationDuration: _propTypes.default.number,
    showOverlay: _propTypes.default.bool,
    overlayBackgroundColor: _propTypes.default.oneOf(_constant.ARR_BACKGROUND_COLORS),
    overlayOpacity: _propTypes.default.string,
    showCloseBtn: _propTypes.default.bool,
    closeBtnAlignment: _propTypes.default.oneOf(_constant2.CLOSE_BUTTON_ALIGNMENTS),
    onClose: _propTypes.default.func,
    headerTitle: _propTypes.default.string,
    withContainerRadius: _propTypes.default.bool,
    fixedHeader: _propTypes.default.bool,
    showHeaderContainerShadow: _propTypes.default.bool,
    isPremiumFlatbed: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    show: true,
    isAnimationOn: true,
    zIndex: _constant2.DEFAULT_STYLE.Z_INDEX,
    height: _constant2.DEFAULT_STYLE.HEIGHT,
    animationDuration: _constant2.DEFAULT_STYLE.ANIMATION_DURATION,
    showOverlay: false,
    overlayBackgroundColor: _constant2.DEFAULT_STYLE.OVERLAY_BG_COLOR,
    overlayOpacity: _constant2.DEFAULT_STYLE.OVERLAY_OPACITY,
    showCloseBtn: false,
    closeBtnAlignment: 'right',
    headerTitle: '',
    withContainerRadius: true,
    fixedHeader: false,
    showHeaderContainerShadow: true,
    isPremiumFlatbed: false
  }
};
exports.default = _default;